import { useEffect } from "react";

export const useSaveScrollPosition = () => {
    useEffect(() => {
      const saveScrollPosition = () => {
        sessionStorage.setItem("scrollPosition", window.scrollY.toString());
      };
  
      document.querySelectorAll('a').forEach(link => {
        link.addEventListener('click', saveScrollPosition);
      });
  
      return () => {
        document.querySelectorAll('a').forEach(link => {
          link.removeEventListener('click', saveScrollPosition);
        });
      };
    }, []);
  };
  

 
export const useRestoreScrollPosition = () => {
  useEffect(() => {
    const savedPosition = sessionStorage.getItem("scrollPosition");
    if (savedPosition) {
      window.scrollTo(0, parseInt(savedPosition));
      sessionStorage.removeItem("scrollPosition");
    }
  }, []);
};

